import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { VscWorkspaceTrusted } from "react-icons/vsc";
import { GrCertificate } from "react-icons/gr";
import { RiCustomerService2Line } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";
import "./About.css";

const About = () => {
  useEffect(() => {
    const images = document.querySelectorAll(".image_about");
    let currentIndex = 0;

    setInterval(() => {
      const previousIndex = currentIndex;
      currentIndex = (currentIndex + 1) % images.length;

      images[previousIndex].classList.remove("active");
      images[currentIndex].classList.add("active");
      images[currentIndex].style.animation = "bounce 0.5s ease-in-out";
      setTimeout(() => {
        images[currentIndex].style.animation = "";
      }, 500);
    }, 3000);

    const observer = new IntersectionObserver((entries) => {
      // loop over all the entries
      entries.forEach((entry) => {
        console.log(entry);
        // use a conditional to check if the entry is intersection
        if (entry.isIntersecting) {
          // add show class
          entry.target.classList.add("showleft");
        } else {
          // remove when not intersecting
          entry.target.classList.remove("showleft");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".hiddenleft");
    hiddenElements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <div>
      <div className="bg_banner_product ">
        <h1 style={{ fontFamily: "Nunito" }}>AboutUs</h1>
        <div className="bread_craum">
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Home
          </Link>
          <IoIosArrowForward style={{ color: "#0F172B", marginTop: "4px" }} />
          <Link
            to="/about"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            About
          </Link>
        </div>
      </div>
      <div class="aboutus-section_my">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-6 col-lg-7">
              <div class="aboutus_my">
                <h2
                  class="aboutus-title_my"
                  style={{
                    borderColor: "orange",
                    borderLeftStyle: "solid",
                    backgroundColor: "#474065",
                    padding: "5px",
                    color: "white",
                  }}
                >
                  About Us{" "}
                </h2>
                <p
                  class="aboutus-text_my"
                  style={{ textAlign: "justify", color: "black" }}
                >
          Gifco Auto Filters India (GAFI), your premier destination for top-quality filtration solutions designed specifically for heavy automotive vehicles. With over 26 years of dedicated expertise, GAFI specializes in crafting superior diesel filters, fuel strainers, and oil filters, tailored to meet the diverse needs of the automotive industry. Located in the heart of Bangalore, India, our state-of-the-art facility ensures unmatched performance and reliability in every product we deliver.
                </p>
                <p
                  class="aboutus-text_my"
                  style={{ textAlign: "justify", color: "black" }}
                >
                  At GAFI, we remain committed to staying ahead of the curve by embracing the latest technological advancements and incorporating valuable customer feedback into our continuous improvement processes. This steadfast dedication ensures that our filtration solutions consistently set the industry standard for excellence. Experience the GAFI advantage today and discover firsthand why we are the trusted choice for heavy automotive filtration needs. Welcome to the pinnacle of excellence. Welcome to GAFI.
                </p>
              </div>
            </div>

            <div
              class="col-md-5 col-sm-6 col-xs-12 "
              style={{ marginTop: "81px" }}
            >
              <div class="feature_my">
                <div class="feature-box_my">
                  <div class="clearfix_my">
                    <div class="iconset_my">
                      <VscWorkspaceTrusted class="glyphicon glyphicon-cog icon_my fadeInUp-animation_icon1" />
                    </div>
                    <div class="feature-content_my">
                      <h4>
                        <b>Quality Product & Material</b>
                      </h4>
                      <p
                        class="aboutus-text_my"
                        style={{
                          textAlign: "justify",
                          color: "black",
                          fontSize: "16px",
                        }}
                      >
                        {" "}
                        Enhance air purity with our paper-based filters
                     
                        Improve air quality with our advanced fabric filters.
                       
                        Breathe freely with our cotton-based air filters.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="feature-box_my">
                  <div class="clearfix_my">
                    <div class="iconset_my">
                      <GrCertificate class="glyphicon glyphicon-cog icon_my fadeInUp-animation_icon2" />
                    </div>
                    <div class="feature-content_my">
                      <h4>
                        <b>Government Cetificate</b>
                      </h4>
                      <p
                        class="aboutus-text_my"
                        style={{
                          textAlign: "justify",
                          color: "black",
                          fontSize: "16px",
                        }}
                      >
                        ZED BRONZE under MSME Sustainable Certification, {" "}
                        Udhyam Registration Certificate,
                         OTABU Certification.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="feature-box_my">
                  <div class="clearfix_my">
                    <div class="iconset_my">
                      <RiCustomerService2Line class="glyphicon glyphicon-cog icon_my fadeInUp-animation_icon3" />
                    </div>
                    <div class="feature-content_my">
                      <h4>
                        <b>Great support</b>
                      </h4>
                      <p
                        class="aboutus-text_my"
                        style={{
                          textAlign: "justify",
                          color: "black",
                          fontSize: "16px",
                        }}
                      >
                        Efficient Assistance, Our knowledgeable team is here to
                        address all your inquiries promptly, guaranteeing a
                        hassle-free experience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container_about hiddenleft">
        <div class="content_about">
          <h2
            style={{
              borderColor: "orange",
              width: "fit-content",
              borderLeftStyle: "solid",
              backgroundColor: "#474065",
              padding: "5px",
              color: "white",
              marginTop: "14px",
              marginBottom: "36px",
            }}
          >
            Mission
          </h2>
          <p style={{ color: "black" }}>
            To engineer and deliver unparalleled filtration solutions, Gifco
            Auto Filters India (GAFI) is committed to leveraging over 26 years
            of industry expertise to ensure heavy automotive vehicles operate at
            optimal efficiency and reliability. Our mission is to exceed
            customer expectations by consistently providing top-quality diesel
            filters, fuel strainers, and oil filters that meet the evolving
            needs of the automotive sector.
          </p>
        </div>
        <div class="image-container_about">
          <div
            class="image_about active"
            style={{
              backgroundImage: `URL(./images/ab1.jpg)`,
              borderRadius: "5px",
              margin: "5px", // Replace with dynamic URLs
            }}
          ></div>
          <div
            class="image_about"
            style={{
              backgroundImage: `url(./images/ab2.jpg)`,
              borderRadius: "5px",
              margin: "5px", // Replace with dynamic URLs
            }}
          ></div>
          <div
            class="image_about"
            style={{
              backgroundImage: `url(./images/ab3.jpg)`,
              borderRadius: "5px",
              margin: "5px", // Replace with dynamic URLs
            }}
          ></div>
        </div>
      </div>

      <div class="container_about  fadeInLeft-animation">
        <div class="image-container_about">
          <div
            class="image_about active"
            style={{
              backgroundImage: `url(./images/ab4.jpg)`,
              borderRadius: "5px",
              margin: "5px", // Replace with dynamic URLs
            }}
          ></div>
          <div
            class="image_about"
            style={{
              backgroundImage: `url(./images/ab5.jpg)`,
              borderRadius: "5px",
              margin: "5px", // Replace with dynamic URLs
            }}
          ></div>
          <div
            class="image_about"
            style={{
              backgroundImage: `url(./images/ab1.jpg)`,
              borderRadius: "5px",
              margin: "5px", // Replace with dynamic URLs
            }}
          ></div>
        </div>
        <div class="content_about">
          <h2
            style={{
              borderColor: "orange",
              width: "fit-content",
              borderLeftStyle: "solid",
              backgroundColor: "#474065",
              padding: "5px",
              color: "white",
              marginTop: "14px",
              marginBottom: "36px",
            }}
          >
            Vision
          </h2>
          <p style={{ color: "black" }}>
            As industry pioneers, GAFI envisions revolutionizing the automotive
            filtration landscape through innovation, reliability, and
            customer-centricity. We strive to remain at the forefront of
            technological advancements, continuously adapting to industry trends
            and customer feedback. Our vision is to be the preferred global
            choice for heavy automotive filtration solutions, recognized for our
            commitment to excellence, sustainability, and customer satisfaction.
          </p>
        </div>
      </div>

      <div className='certificate_main_container hiddenleft'>
    <div className="content_about resposnive_content_about" style={{ fontFamily:"poppins,sans serif",
      color:"#888888",fontSize: "16px",color:"black" }}>
    <h2 style={{ borderColor: "orange", width: "fit-content", borderLeftStyle: "solid", backgroundColor: "#474065", padding: "5px", color: "white" }}>Why Us</h2>
    <ul style={{ marginLeft: "4px", fontSize: "16px" }}>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Decades of Expertise :</b> Gifco Auto Filters India (GAFI) boasts over 26 years of expertise in providing top-notch filtration solutions for heavy automotive vehicles.</li>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Commitment to Excellence :</b> Our dedication to excellence and innovation sets us apart as the premier choice for your filtration needs.</li>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Innovative Technology :</b> Focus on cutting-edge technology, we lead the industry in delivering advanced filtration products tailored to your specific requirements.</li>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Customer Satisfaction Priority :</b> At GAFI, customer satisfaction is our utmost priority.</li>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Responsive to Feedback :</b> We actively listen to feedback and continuously refine our products to meet the evolving needs of the automotive sector.</li>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Unmatched Support and Realiabilty :</b> Expect unparalleled support and reliability when you choose GAFI for your filtration solutions.</li>
    <li style={{ listStyleType: "none" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#000", marginRight: "10px" }}></span><b>Globally Recognized :</b> Our global recognition underscores our commitment to excellence, sustainability, and customer satisfaction.</li>
    </ul>
    
  </div>

  <div className='cerificate_container resposnive_content_about'>
       <img src="./images/whyus.PNG" alt="" style={{height:"380px", width:"570px",marginTop:"60px",borderRadius:"18px",boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"}}/>
    </div>

    </div>
     

      <div>
        <div
          className="content_about"
          style={{
            marginLeft: "98px",
            fontFamily: "poppins,sans serif",
            color: "#888888",
            fontSize: "16px",
            color: "black",
            marginTop:"50px"
          }}
        >
          <h2
            style={{
              borderColor: "orange",
              width: "fit-content",
              borderLeftStyle: "solid",
              backgroundColor: "#474065",
              padding: "5px",
              color: "white",
            }}
          >
            Certifications
          </h2>
        </div>
        <div className="certififcate hiddenleft" style={{marginBottom:'50px'}}>
          <div>
            <img
              src="/images/Bronze_page-0001.jpg"
              alt=""
          
              className="responisve_all_cerficate_image"
            />
          </div>
          <div>
            <img
              src="/images/certificate2.jpg"
              alt=""
              className="responisve_all_cerficate_image"
            />
          </div>
          <div>
            <img
              src="/images/certificate3.jpg"
              alt=""
              className="responisve_all_cerficate_image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
